import { useState,useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Box, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, SwipeableDrawer, Tab, Table, TableBody, TableCell, TableRow, Tabs } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { DatePicker } from 'zaman'
import { post } from '../../../utils/axios'
import Button from '../../../components/Button'
import axios from 'axios'

import './Transactions.css'
import { toast } from 'react-toastify'

const Transactions = () => {

    const {id} = useParams()
    const [showLoading,setShowLoading] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [pdfIsLoading,setPdfIsLoading] = useState(false)
    const [currentTab,setCurrentTab] = useState(0)
    const [todayTransactions,setTodayTransactions] = useState([])
    const [todayTransactionsLoading,setTodayTransactionsLoading] = useState(true)
    const [getData,setGetData] = useState(false)
    const [fromDate,setFromDate] = useState(new Date())
    const [toDate,setToDate] = useState(new Date())
    const [transactions,setTransactions] = useState([])
    const [page,setPage] = useState(1)
    const [totalPrice,setTotalPrice] = useState(0)
    const [count,setCount] = useState([])
    const [pages,setPages] = useState([])
    const [order,setOrder] = useState([])
    const [showDrawer,setShowDrawer] = useState(false)
    const [segmentTitle,setSegmentTitle] = useState('')

    useEffect(() => {
        const today = new Date()
        const postedData = {
            fromDate: today.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            toDate: today.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            offset: 1,
            limit: 100
        }
        if(id){
            postedData.segmentHashId = id
            post('Card/GetTransaction',postedData).then(({data}) => {
                if(data.isSuccess)
                    setTodayTransactions(data.data.result)
            }).finally(() => setTodayTransactionsLoading(false))
            axios.post('https://petromaht.sabinarya.com/service/api/Info/getSegmentData').then(({data}) => {
                if(data.status){
                    const titles = data.result
                    const title = titles.find(t => t.value == id)
                    if(title)
                        setSegmentTitle(title.title)
                }
            })
        }else{
            post('Card/GetTransaction',postedData).then(({data}) => {
                if(data.isSuccess)
                    setTodayTransactions(data.data.result)
            }).finally(() => setTodayTransactionsLoading(false))
        }
    },[])

    const handleFromDate = date => {
        setFromDate(date)
        document.getElementsByClassName('rdp__overlay')[0].click()
    }

    const handleToDate = date => {
        setToDate(date)
        document.getElementsByClassName('rdp__overlay')[0].click()
    }

    const downloadTransactionPdf = () => {
        setPdfIsLoading(true)
        const postedData = {
            fromDate: fromDate.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            toDate: toDate.toLocaleDateString('fr-CA').replace(/-/g,'/')
        }
        post('Card/GetTransactionFile',postedData).then(({ data }) => {
            if(data.isSuccess)
                window.open(data.data.url)
            else
                toast.error(data.message)
        }).finally(() => {
            setPdfIsLoading(false)
        })
    }

    const getTransactions = (currentPage = null) => {
        setGetData(false)
        setTransactions([])
        setIsLoading(true)
        const postedData = {
            fromDate: fromDate.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            toDate: toDate.toLocaleDateString('fr-CA').replace(/-/g,'/'),
            offset: currentPage || page,
            limit: 10
        }
        if(id)
            postedData.segmentHashId = id
        post('Card/GetTransaction',postedData).then(({data}) => {
            if(data.isSuccess){
                setTransactions(data.data.result)
                if(data.data.count[0]){
                    setCount(data.data.count[0].cntTotal)
                    let calcPages = Math.ceil((data.data.count[0].cntTotal ? data.data.count[0].cntTotal : 10) / 10);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    setPages(pagesArray)
                }
            }
        }).finally(() => {
            setIsLoading(false)
            setGetData(true)
        })
    }

    const changePage = currentPage => {
        setPage(currentPage)
        getTransactions(currentPage)
    }

    const convertTime12to24 = time12h => {
        const [time,modifier] = time12h.split(' ')
        let [hours,minutes] = time.split(':')
        if(hours === '12')
            hours = '00'
        if(modifier === 'PM')
            hours = parseInt(hours, 10) + 12
        return `${hours}:${minutes}`
    }

    const handleDrawer = (orderId = null,rrn = null) => {
        setShowDrawer(true)
        setShowLoading(true)
        setOrder([])
        setTotalPrice(0)
        const postedData = {}
        if(orderId)
            postedData.serviceConsumerId = orderId
        else
            postedData.rrn = rrn
        post('Order/GetOrder',postedData).then(({data}) => {
            if(data.isSuccess){
                let calcTotalPrice = 0
                let generatedOrder = []
                let itemIndex = 0
                data.data.subServiceId.map(item => {
                    calcTotalPrice += item.price
                    itemIndex = generatedOrder.findIndex(i => i.id === item.id)
                    if(itemIndex != -1){
                        generatedOrder[itemIndex].count = generatedOrder[itemIndex].count + 1
                    }else{
                        generatedOrder.push({...item,count: 1})
                    }
                })
                setOrder(generatedOrder)
                setTotalPrice(calcTotalPrice)
            }
        }).finally(() => setShowLoading(false))
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">گزارشات تراکنش ها{segmentTitle ? `ی ${segmentTitle}` : ''}</h3>
            <div className="safe-area">
                <Card sx={{width: '100%',mb: 5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <Box sx={{ borderBottom: 1,borderColor: 'divider',mb: 3 }}>
                            <Tabs value={currentTab} onChange={(e,currentTabIndex) => setCurrentTab(currentTabIndex)}>
                                <Tab label="تراکنش های امروز" />
                                <Tab label="تمام تراکنش ها" />
                            </Tabs>
                        </Box>
                        {currentTab == 0 && <div>
                            {todayTransactionsLoading ? <CircularProgress size={24} sx={{ display: 'table',m: '0 auto' }} /> : (todayTransactions && !todayTransactions.length ? <Alert severity="info" sx={{mt: 2}}>تراکنشی یافت نشد</Alert> : (todayTransactions.length ?
                            <div className="transactions-list">
                                {todayTransactions.map(transaction => <div className={`transaction-list-item${transaction.childName ? ' with-name' : ''}`} key={Math.random()} onClick={() => transaction.traceno ? handleDrawer(null,transaction.traceno) : false}>
                                    <div className="transaction-item-row">
                                        <span className="transaction-business">{transaction.businessTitle || '-'}</span>
                                        <span className={`transaction-status ${transaction.respanse == 'موفق' ? 'success' : 'error'}`}>{transaction.respanse.toString()}</span>
                                    </div>
                                    <div className="transaction-item-row">
                                        <span className="transaction-amount">مبلغ : {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount)} ریال</span>
                                        <span className="transaction-date">{`${transaction.dateTran.slice(0,4)}/${transaction.dateTran.slice(4,6)}/${transaction.dateTran.slice(6,8)} - ${convertTime12to24(transaction.timeTran)}`}</span>
                                    </div>
                                    {transaction.childName ? <div className="transaction-item-row">
                                        <span>{transaction.childName}</span>
                                    </div> : ''}
                                    <div className="transaction-item-row">
                                        <span>نوع تراکنش : {transaction.paymentType || '-'}</span>
                                    </div>
                                </div>)}
                            </div>
                            : ''))}
                            {todayTransactions && todayTransactions.length ? <p className="transactions-count">تعداد کل : {todayTransactions.length}</p> : ''}
                        </div>}
                        {currentTab == 1 && <div>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <div className="form__group">
                                        <DatePicker inputClass="form__field" onChange={e => handleFromDate(e.value)} defaultValue={fromDate} />
                                        <label className="form__label">از تاریخ</label>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="form__group">
                                        <DatePicker inputClass="form__field" onChange={e => handleToDate(e.value)} defaultValue={toDate} />
                                        <label className="form__label">تا تاریخ</label>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: -1.5,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={() => getTransactions()}>دریافت لیست تراکنش ها</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button type="submit" isLoading={pdfIsLoading} fullWidth={true} sx={{mt: .5,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={() => downloadTransactionPdf()}>دانلود PDF لیست تراکنش ها</Button>
                                </Grid>
                            </Grid>
                            {getData ? <hr style={{height: 1,backgroundColor: 'rgb(210,210,210)',marginTop: 15}} /> : ''}
                            {getData && !transactions.length ? <Alert severity="info" sx={{mt: 2}}>تراکنشی یافت نشد</Alert> : (transactions.length ?
                            <div className="transactions-list">
                                {transactions.map(transaction => <div className={`transaction-list-item${transaction.childName ? ' with-name' : ''}`} onClick={() => transaction.traceno ? handleDrawer(null,transaction.traceno) : false} key={`${Math.random()}-${transaction.traceno}`}>
                                    <div className="transaction-item-row">
                                        <span className="transaction-business">{transaction.businessTitle}</span>
                                        <span className={`transaction-status ${transaction.respanse == 'موفق' ? 'success' : 'error'}`}>{transaction.respanse.toString()}</span>
                                    </div>
                                    <div className="transaction-item-row">
                                        <span className="transaction-amount">مبلغ : {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount)} ریال</span>
                                        <span className="transaction-date">{`${transaction.dateTran.slice(0,4)}/${transaction.dateTran.slice(4,6)}/${transaction.dateTran.slice(6,8)} - ${convertTime12to24(transaction.timeTran)}`}</span>
                                    </div>
                                    {transaction.childName ? <div className="transaction-item-row">
                                        <span>{transaction.childName}</span>
                                    </div> : ''}
                                    <div className="transaction-item-row">
                                        <span>نوع تراکنش : {transaction.paymentType || '-'}</span>
                                    </div>
                                </div>)}
                            </div>
                            : '')}
                            {getData && transactions.length ? <p className="transactions-count">نمایش {count <= 10 || pages.length < 1 ? count : 10} عدد از تعداد کل : {count}</p> : ''}
                            {getData && pages.length > 1 && transactions.length ? <FormControl fullWidth sx={{mt: 3}}>
                                <InputLabel id="app-theme-label">انتخاب صفحه</InputLabel>
                                <Select labelId="app-theme-label" label="انتخاب صفحه" value={page} onChange={e => changePage(e.target.value)}>
                                    {pages.map(page => <MenuItem key={page} value={page}>{page}</MenuItem>)}
                                </Select>
                            </FormControl> : ''}
                        </div>}
                    </CardContent>
                </Card>
            </div>
            <SwipeableDrawer anchor="bottom" open={showDrawer} onClose={() => setShowDrawer(false)} onOpen={() => setShowDrawer(true)} className="order-detail-drawer">
                {showLoading ? <CircularProgress size={28} style={{display: 'table',margin: '25px auto'}} /> : (Object.keys(order).length ? <>
                <h4>جزئیات سفارش</h4>
                <Table>
                    <TableBody>
                        {order && order.length ? order.map((item,index) => <TableRow key={index} sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                            <TableCell align="right">{item.title} <i className="fal fa-xmark"></i> {item.count}</TableCell>
                            <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price * item.count)} ریال</TableCell>
                        </TableRow>) : ''}
                        <TableRow sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 3}}}>
                            <TableCell align="right"><b>مجموع</b></TableCell>
                            <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice)} ریال</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </> : <Box sx={{px: 2}}><Alert severity="info" sx={{my: 3}}>اطلاعات سفارش یافت نشد</Alert></Box>)}
            </SwipeableDrawer>
        </Grid>
    )
}

export default Transactions